import { TabProps } from "../Tab";

/**
 * Gets the tab from the set of tabs with the specified ID.
 * @param tabs The tabs.
 * @param id The ID of the tab to locate.
 * @returns The tab with the specified ID, or null if none found.
 */
export function getTab(tabs: ReadonlyArray<TabProps>, id: string | null): TabProps | null {
  if (id === null) return null;

  return tabs.find((props) => props.id === id) ?? null;
}
